import { tickets } from "../types";

export const createIndependentTickets = ({
    activeTab,
    type,
    projectId,
    data,
    existing,
    addNew,
    customerId,
    endUserId,
    limit,
    page,
    refresh = true,
    endUserForm,
    formName,
    navigate,
    file,
    setgtag,
}) => ({
    type: tickets.CREATE_INDEPENDENT_TICKETS_REQUEST,
    payload: { activeTab, type, projectId, data, existing, addNew, customerId, endUserId, limit, page, refresh, endUserForm, formName, navigate, file, setgtag },
});

export const getTicketsList = ({ activeTab, projectId, customerId, endUserId, siteId, limit = 10, page = 1, count = false, type = 0, next = true, offset = 0, navigate }) => ({
    type: tickets.TICKETS_LIST_REQUEST,
    payload: { activeTab, projectId, customerId, endUserId, siteId, limit, page, count, type, next, offset, navigate }
})

export const viewTicketById = ({ ticketId, externalTicketId, paymentTransaction = false }) => ({
    type: tickets.VIEW_TICKET_REQUEST,
    payload: { ticketId, externalTicketId, paymentTransaction }
})